export interface SimpleUser {
  id: number
  name: string
}

export interface User {
  id: number
  first_name: string
  last_name: string
  email: string
  type: UserGroupType.USER
}

export interface Group {
  id: number
  name: string
  email?: string | null
  type: UserGroupType.GROUP
}

export interface UsersAndGroups {
  users: User[]
  groups: Group[]
}

export interface GetUsersQuery {
  perimeter_id?: number
  tag_id?: number
  role?: UserSelectRoles
}

export enum UserSelectRoles {
  PILOT = 'pilot',
  CONTRIBUTOR = 'contributor',
  AUDITOR = 'auditor',
}

export enum UserGroupType {
  USER = 'user',
  GROUP = 'group',
}

export interface UserExtended extends SimpleUser {
  email: string
  initials: string
}
